module.exports = __webpack_public_path__ + "img/mail_amarelo.cd0bbbdd.svg";